module.exports = __webpack_public_path__ + "static/media/6s.d612f752.png";